import { CategoryDto } from "definitions/product-storage/models/category-dto";
import { SelectOptionTree } from "src/components/CategorySelectTree";

/**
 * Преобразует плоский список категорий в древовидную структуру
 * @param categories Список категорий
 * @returns Древовидная структура категорий
 */
export const categoriesToTree = (
  categories: CategoryDto[],
): SelectOptionTree[] => {
  const categoriesMap = new Map<number, CategoryDto>();
  const rootCategories: SelectOptionTree[] = [];

  // Создаем карту категорий по ID
  categories.forEach((category) => {
    if (category.id !== undefined) {
      categoriesMap.set(category.id, category);
    }
  });

  // Строим дерево
  categories.forEach((category) => {
    if (category.id === undefined) return;

    const treeNode: SelectOptionTree = {
      value: category.id,
      label: category.name,
      options: [],
      productCount: category.productCount,
    };

    if (category.parentId === null || category.parentId === undefined) {
      rootCategories.push(treeNode);
    } else {
      const parent = categoriesMap.get(category.parentId);
      if (parent && parent.id !== undefined) {
        const parentTreeNode = findTreeNode(rootCategories, parent.id);
        if (parentTreeNode) {
          parentTreeNode.options?.push(treeNode);
        }
      }
    }
  });

  return rootCategories;
};

const findTreeNode = (
  nodes: SelectOptionTree[],
  value: number,
): SelectOptionTree | null => {
  for (const node of nodes) {
    if (node.value === value) {
      return node;
    }
    const found = findTreeNode(node.options || [], value);
    if (found) {
      return found;
    }
  }
  return null;
};
